<template>
  <div class="n-card-item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: `NCardItem`,
};
</script>

<style lang="scss" scoped>
  .n-card-item {
    font-weight: 500;
    font-size: 1rem;
  }
</style>
